import Text from '@/components/ui/Text';

const MetaItem = ({ children, className }: MetaItemProps) => (
  <div
    className={`relative flex items-center px-4 before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2 before:h-4 before:w-[2px] before:bg-primary ${className ?? ''}`}
  >
    <Text as="p" variant="paragraph" className="mb-0!">
      {children}
    </Text>
  </div>
);

export default MetaItem;

type MetaItemProps = {
  children: React.ReactNode;
  className?: string;
};
